import { render, staticRenderFns } from "./gongnengpeizhiDialog.vue?vue&type=template&id=6380cd88&scoped=true"
import script from "./gongnengpeizhiDialog.vue?vue&type=script&lang=js"
export * from "./gongnengpeizhiDialog.vue?vue&type=script&lang=js"
import style0 from "./gongnengpeizhiDialog.vue?vue&type=style&index=0&id=6380cd88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6380cd88",
  null
  
)

export default component.exports